export { default } from './Breadcrumbs';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Breadcrumbs/index.js
// module id = 811
// module chunks = 2